import React, { useEffect, useMemo, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

function BoxAnimationExpand({ children, customProps }: Props) {
    const ref = useRef(null);
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const isInView = useInView(ref, { once: windowSize.current[0] > 1024 ? false : true });
    const mainControls = useAnimation();
    const direction = customProps?.direction;
    const directionType = customProps?.directionType;
    const delay = customProps?.delay || 0;
    const extraDelay = customProps?.extraDelay ? 2 : 0;
    const animationType = useMemo(() => {
        const offset = directionType === "minus" ? -20 : 20;

        if (direction === "left") {
            return {
                hidden: { x: offset, opacity: 0 },
                visible: {
                    x: 0,
                    opacity: 1
                }
            };
        }

        return {
            hidden: { y: offset, opacity: 0 },
            visible: {
                y: 0,
                opacity: 1
            }
        };
    }, [direction, directionType]);

    useEffect(() => {
        if (isInView) {
            mainControls.set("hidden");
            mainControls.start("visible");
        }
    }, [animationType, isInView, mainControls]);

    return (
        <motion.div
            ref={ref}
            style={{ width: "100%", height: "100%" }}
            variants={animationType}
            initial="hidden"
            animate={mainControls}
            transition={{ duration: 1, delay: delay + extraDelay }}
        >
            {children}
        </motion.div>
    );
}

interface Props {
    children: React.ReactNode;
    customProps?: {
        position?: string;
        width?: string;
        delay?: number;
        extraDelay?: boolean;
        direction?: string;
        directionType?: string;
    };
}

export default BoxAnimationExpand;
